import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { checklistSubmissionApi } from 'src/Services/API';

const useFetchChecklistSubmissions = (checklistId?: string) => {
  const assetId = useCurrentAssetId();

  return useQuery({
    queryKey: ['fetch-checklist-submissions', checklistId],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');
      if (!checklistId) throw new Error('No checklistId provided');

      return (
        await checklistSubmissionApi.checklistSubmissionsControllerFindAllByChecklist(
          checklistId,
          assetId
        )
      ).data;
    },
    enabled: !!assetId && !!checklistId,
    staleTime: 60 * 60 * 1000,
    cacheTime: 60 * 60 * 1000,
  });
};

export default useFetchChecklistSubmissions;
